import { styled } from "@mui/material/styles";
import { Paper, Typography } from "@mui/material";

import { relativeCTABackgrounds } from "utils/relativeUtils";
import ResponsiveImage from "components/ResponsiveImage";
import SpinningCloseButton from "components/SpinningCloseButton";

export const StyledPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "relation",
})(({ theme, relation }) => {
  const backgrounds = relativeCTABackgrounds(theme);
  const relationBackground = relation && backgrounds[relation] ? backgrounds[relation] : {};

  return {
    width: 260,
    minHeight: 450,
    padding: "44px 26px 28px",
    position: "relative",
    borderRadius: 10,
    ...relationBackground,
  };
});

export const StyledSpinningCloseButton = styled(SpinningCloseButton)(({ theme }) => ({
  padding: 0,
  position: "absolute",
  right: 20,
  top: 20,
  width: 24,
  height: 24,
  "&.MuiButtonBase-root": {
    fontSize: theme.typography.pxToRem(12),
  },
}));

export const Content = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const Figure = styled("figure")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 20,
});

export const StyledResponsiveImage = styled(ResponsiveImage)({
  maxWidth: 128,
  maxHeight: 128,
  objectFit: "scale-down",
});

export const StyledTitle = styled(Typography)({
  marginBottom: 19,
});

export const StyledDescription = styled(Typography)({
  marginBottom: 28,
});
